import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from '../../service/local-storage.service';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { DatePipe } from '@angular/common';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-sleep-reminder',
  templateUrl: './sleep-reminder.component.html',
  styleUrl: './sleep-reminder.component.scss'
})
export class SleepReminderComponent implements OnInit {
  sleepReminderForm: any = FormGroup;
  buttonclick: boolean = false;
  sleepHistoryData: any;
  submitted = false;
  userId: any;
  @ViewChild('startTimeInput') startTimeInput!: ElementRef;
  datePipe = new DatePipe("en-US")

  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    public dialog: MatDialog,
    private toasterService: ToasterServiceService
  ) {
    this.userId = JSON.parse(localStorageService.getItem("loginData") || '{}').user_id;
    this.sleepReminderForm = this.fb.group({
      sleep_id: [0],
      start_time: ['', Validators.required],
      end_time: ['', Validators.required],
    })
  }

  ngOnInit() {
    this.getSleepList();
  }

  get f() {
    return this.sleepReminderForm.controls;
  }

  getSleepList() {
    this.mainService.getApi(ApiUrls.historySleep + this.userId).subscribe((res: any) => {
      if (res.status === 1) {
        this.sleepHistoryData = res.sleep.map((item: any) => ({
          ...item,
          is_active: +item.is_active,
          start_time: this.extractTime(item.start_time),
          end_time: this.extractTime(item.end_time)
        }));        
      }
    });
  }

  extractTime(dateTime: string): string {
    const timePart = dateTime.split(' ')[1];
    const [hoursMinutes] = timePart.split(':');
    const formattedTime = timePart.substring(0, timePart.lastIndexOf(':'));
    const amPmPart = dateTime.split(' ')[2];
    return `${formattedTime} ${amPmPart}`;
  }

  editSleepData(data: any) {
    this.buttonclick = true;
    const startTime = this.extractHourAndMinute(data.start_time);
    const endTime = this.extractHourAndMinute(data.end_time);
    this.sleepReminderForm.patchValue({
      start_time: startTime,
      end_time: endTime,
      sleep_id: data.sleep_id,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      if (this.startTimeInput && this.startTimeInput.nativeElement) {
        this.renderer.selectRootElement(this.startTimeInput.nativeElement).focus();
      }
    }, 300);
  }

  extractHourAndMinute(time: string): string {
    const [hourMinute, amPm] = time.split(' ');
    const [hour, minute] = hourMinute.split(':');
    return `${hour}:${minute} ${amPm}`;
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteSleepData(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteSleepData(value: any) {
    let data = {
      sleep_id: Number(value.sleep_id),
      user_id: this.userId,
      start_time: "",
      end_time: "",
      created: String(this.localStorageService.getItem('user_id')),
      is_active: value.is_active ? "1" : "0",
      Action: 'DELETE',
    };
    this.mainService.postApi(ApiUrls.sleepStatus, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getSleepList();
      } else {
        this.toasterService.toastError(res.response);
      }
    });
  }

  convertTimeTo24HourFormat(time: string): string {
    let [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    let formattedHours = hours.toString().padStart(2, '0');
    let formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:00`;
  }

  addSleepReminder() {
    this.submitted = true;
    if (this.sleepReminderForm.valid) {
      let date = new Date();
      const currentDate = this.datePipe.transform(date, "yyyy-MM-dd");
      const { start_time, end_time } = this.sleepReminderForm.value;
      let formatedStartTime = this.convertTimeTo24HourFormat(start_time);
      let formatedEndTime = this.convertTimeTo24HourFormat(end_time);

      let data = {
        sleep_id: 0,
        user_id: this.userId,
        start_time: `${currentDate} ${formatedStartTime}`,
        end_time: `${currentDate} ${formatedEndTime}`,
        created: String(this.localStorageService.getItem('user_id')),
        is_active: "1",
        Action: 'INSERT',
      };
      this.mainService.postApi(ApiUrls.addEditSleepReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.sleepReminderForm.reset();
          this.submitted = false;
          this.getSleepList();
          this.toasterService.toastSuccess(res.response);
          this.mainService.triggerProfileData(1);
        } else {
          this.toasterService.toastError(res.response);
        }
      })
    }
    else {
      this.submitted = true;
    }
  }

  editSleepReminder() {
    let date = new Date();
    const currentDate = this.datePipe.transform(date, "yyyy-MM-dd");
    const { start_time, end_time } = this.sleepReminderForm.value;
    let formatedStartTime = this.convertTimeTo24HourFormat(start_time);
    let formatedEndTime = this.convertTimeTo24HourFormat(end_time);
    let data = {
      sleep_id: this.sleepReminderForm.value.sleep_id,
      user_id: this.userId,
      start_time: `${currentDate} ${formatedStartTime}`,
      end_time: `${currentDate} ${formatedEndTime}`,
      created: String(this.localStorageService.getItem('user_id')),
      is_active: "1",
      Action: 'UPDATE',
    };
    if (this.sleepReminderForm.valid) {
      this.mainService.postApi(ApiUrls.addEditSleepReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.sleepReminderForm.reset();
          this.submitted = false;
          this.buttonclick = false;
          this.getSleepList();
          this.toasterService.toastSuccess(res.response);
        } else {
          this.toasterService.toastError(res.response);
        }
      })
    }
    else {
      this.submitted = true
      this.buttonclick = true;
    }
  }

}
